const Saturation = () => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 94 94"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.103516"
        width="93.2471"
        height="93.2471"
        rx="46.6236"
        transform="rotate(0.0638669 0.103516 0)"
      />
      <path
        d="M48.2865 11.1932C46.9772 10.1726 45.1573 10.1706 43.8458 11.1883C36.924 16.4585 16.4845 33.6528 16.5713 53.7091C16.5532 69.9434 29.7516 83.2076 46.0223 83.2257C62.2929 83.2438 75.5206 70.0455 75.5387 53.8113C75.5971 34.0463 55.1601 16.5153 48.2865 11.1932Z"
        stroke="black"
        strokeWidth="6.85067"
        strokeMiterlimit="10"
      />
      <path
        d="M46.0605 10.4268L45.9794 83.226"
        stroke="black"
        strokeWidth="6.85067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.9926 72.1603L74.0356 58.5781"
        stroke="black"
        strokeWidth="6.85067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.0148 53.9608L72.8558 40.9596"
        stroke="black"
        strokeWidth="6.85067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.035 35.7607L64.354 26.8632"
        stroke="black"
        strokeWidth="6.85067"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Saturation;
